import { Injectable } from '@angular/core'

export type Sound =
  '../../../assets/sounds/welcome.wav' |
  '../../../assets/sounds/message_send.wav' |
  '../../../assets/sounds/message_receive.wav' |
  '../../../assets/sounds/ticket_tear.wav' |
  '../../../assets/sounds/notification.wav' |
  '../../../assets/sounds/error.wav'

export const Sound = {
  Welcome: '../../../assets/sounds/welcome.wav' as Sound,
  MessageSent: '../../../assets/sounds/message_send.wav' as Sound,
  MessageReceived: '../../../assets/sounds/message_receive.wav' as Sound,
  TicketTear: '../../../assets/sounds/ticket_tear.wav' as Sound,
  Notification: '../../../assets/sounds/notification.wav' as Sound,
  Error: '../../../assets/sounds/error.wav' as Sound
}
// export class Sound {
//   public static readonly ID = {
//     Welcome: '../../../assets/sounds/welcome.wav',
//     MessageSent: '../../../assets/sounds/message_send.wav',
//     MessageReceiver: '../../../assets/sounds/message_receive.wav',
//     TicketTear: '../../../assets/sounds/ticket_tear.wav',
//     Notification: '../../../assets/sounds/notification.wav',
//     Error: '../../../assets/sounds/error.wav'
//   }
// }


@Injectable()
export class AudioService {

  constructor() { }

  public playSound(sound: Sound) {
    if (this.isSoundEnabled()) {
      const audio = new Audio(sound)
      audio.play()
    }
  }

  public enableSound(flag: boolean) {
    window.localStorage.setItem('sound_enabled', flag.toString())
  }

  public isSoundEnabled(): boolean {
    const value = window.localStorage.getItem('sound_enabled')
    if (value === null) {
      return true
    }

    return value === 'true'
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/audio/audio.service.ts